// extracted by mini-css-extract-plugin
export default {"custom-alert":"Alert_custom-alert__rDm2M"};